import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    platform: [
      { label: "Bizznet Empresas", path: "/business-benefits-landing" },
      { label: "Bizznet Usuarios", path: "/user-benefits-landing" },
      { label: "Bizznet Rewards", path: "/bizznet-rewards-program" },
      { label: "Directorio Empresarial", path: "/business-directory-benefits-landing" }
    ],
    support: [
      { label: "Quiénes Somos", path: "/about-us" },
      { label: "Preguntas Frecuentes", path: "/faq" },
      { label: "Términos y Condiciones", path: "/terms-and-conditions" },
      { label: "Política de Privacidad", path: "/privacy-policy" }
    ],
    contact: [
      { icon: "MapPin", text: "Pasto, Nariño, Colombia" },
      { icon: "Mail", text: "bizznet.latam@gmail.com" },
      { icon: "Phone", text: "+57 315 249 5959" },
      { icon: "Clock", text: "Lun - Vie: 8:00 AM - 6:00 PM" }
    ]
  };

  const socialMedia = [
    { icon: "Facebook", url: "https://www.facebook.com/profile.php?id=61584567389115", label: "Facebook" },
    { icon: "Instagram", url: "https://www.instagram.com/bizznet.app?igsh=ODZiaGZxN3VieWZs", label: "Instagram" },
    { icon: "Music", url: "https://tiktok.com/@bizznet.app", label: "TikTok" }
  ];

  const paymentMethods = [
    { name: "Nequi", icon: "Smartphone" },
    { name: "Bancolombia", icon: "Building2" },
    { name: "Tarjetas", icon: "CreditCard" }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/assets/images/9916af0d-0004-4cc9-8806-3554d0133a8f-1765669565979.jpg" 
                alt="Logo mejorado de BIZZNET más compacto con símbolo geométrico en tonos azules y texto BIZZNET en negro más cerca del símbolo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              La plataforma líder en descuentos exclusivos y marketing digital para negocios en Colombia.
            </p>
            <div className="flex gap-3">
              {socialMedia?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-9 h-9 bg-muted hover:bg-primary hover:text-primary-foreground rounded-lg transition-colors"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground mb-4">Plataforma</h3>
            <ul className="space-y-2">
              {footerLinks?.platform?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground mb-4">Soporte</h3>
            <ul className="space-y-2">
              {footerLinks?.support?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground mb-4">Contacto</h3>
            <ul className="space-y-3">
              {footerLinks?.contact?.map((item, index) => (
                <li key={index} className="flex items-start gap-2">
                  <Icon name={item?.icon} size={16} className="text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">{item?.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-muted-foreground">
              © {currentYear} BIZZNET. Todos los derechos reservados.
            </div>

            <div className="flex items-center gap-4">
              <span className="text-sm text-muted-foreground">Métodos de pago:</span>
              <div className="flex gap-2">
                {paymentMethods?.map((method) => (
                  <div
                    key={method?.name}
                    className="flex items-center justify-center w-10 h-10 bg-muted rounded-lg"
                    title={method?.name}
                  >
                    <Icon name={method?.icon} size={20} className="text-foreground" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-4 text-center">
            <p className="text-xs text-muted-foreground">
              <Icon name="Shield" size={14} className="inline mr-1" />
              Plataforma verificada y segura. Certificado SSL. Datos protegidos según normativa colombiana.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;